<div class="no-data-container">
    <div class="icon-wrapper">
        <hugeicons-icon [icon]="icon" [size]="iconSize" color="currentColor"></hugeicons-icon>
    </div>
    <div class="no-data-title">{{ title }}</div>
    <div class="no-data-description">{{ description }}</div>
    <ng-content></ng-content>
</div>